import React, { useEffect } from "react";
import "./App.css";
import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Stats from "./components/Stats";
import Testimonials from "./components/Testimonials";
import Emergency from "./components/Emergency";
import Partners from "./components/Partners";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

// Inner component: has access to language context for meta tags / lang attr.
function AppShell() {
  const { lang } = useLanguage();

  useEffect(() => {
    document.documentElement.lang = lang === "EN" ? "en" : "fr";

    const isEN = lang === "EN";
    document.title = isEN
      ? "MAG Protection - Private Security Company in Luxembourg"
      : "MAG Protection - Société de Sécurité Privée au Luxembourg";

    const setMeta = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta(
      "description",
      isEN
        ? "MAG Protection - Your trusted partner for private security in Luxembourg. Guarding, close protection, event security, 24/7 remote monitoring."
        : "MAG Protection - Votre partenaire de confiance pour la sécurité privée au Luxembourg. Gardiennage, protection rapprochée, événementiel, télésurveillance 24/7."
    );

    setMeta(
      "keywords",
      isEN
        ? "security Luxembourg, guarding, close protection, MAG Protection, private security, remote monitoring"
        : "sécurité Luxembourg, gardiennage, protection rapprochée, MAG Protection, sécurité privée, télésurveillance"
    );
  }, [lang]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <About />
      <Stats />
      <Testimonials />
      <Emergency />
      <Partners />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppShell />
    </LanguageProvider>
  );
}

export default App;
